import React from "react";
import { FormStyled } from './Styled';

export default function Index(props) {
  const validateMessages = {
    required: "กรุณากรอก ${label}",
    types: {
      email: "${label} ไม่ถูกต้อง",
    },
  };
  
  const onFinish = (values) => {
    alert('no function handle finish on this form');
  };

  return (
    <FormStyled
      form={props.form}
      labelCol={{span: 24}}
      wrapperCol={{span: props.column == 2 ? 23 : 24}}
      name={props.name}
      className={props.name + ' ' +(props.column ? 'column-'+props.column : '') + ' ' + (props.className ? props.className : '')}
      onFinish={props.onFinish ? props.onFinish : onFinish}
      validateMessages={props.validateMessages ? props.validateMessages : validateMessages}
      size={"large"}
      column={props.column}      
    >
      {props.inputs}
    </FormStyled>
  );
}
